const EmployeeProfile = (props) => {
    const { employee, employeeId } = props;
    return (
        <div className="flex items-center gap-3">
            <div>
                <div className="font-medium">{employee}</div>
                <div className="text-gray-600 text-xs">{employeeId}</div>
            </div>
        </div>
    );
}

export default EmployeeProfile;
